module.exports = __webpack_public_path__ + "img/Like.30b97957.svg";